import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useContext } from 'react';
import { MdDragIndicator } from 'react-icons/md';
import { BsKanban, BsFillPencilFill, BsTrashFill } from 'react-icons/bs';
import { useNavigate, useParams } from 'react-router-dom';
import { httpsCallable } from "firebase/functions";
import { FirebaseContext } from '../services/Firebase';
import toast from 'react-hot-toast';

const ModuleCard = ({
    id,
    name,
    goal,
    order
}: any) => {
    const { id: trainingId } = useParams();
    const { functions } = useContext(FirebaseContext) || {}
    const navigate = useNavigate()
    const {
        setNodeRef,
        attributes,
        listeners,
        transition,
        transform,
        isDragging,
    } = useSortable({ id: id })

    const style = {
        transition,
        transform: CSS.Transform.toString(transform),
        opacity: isDragging ? 0.5 : 1,
    }

    const onClick = (e: any) => {
        e.preventDefault()
        navigate(`/training/${trainingId}/modules/${id}`, { state: {name, goal }})
    }

    const onEdit = (e: any) => {
      e.preventDefault()
      navigate(`/training/${trainingId}/modules/${id}/modify`, { state: {name, goal }})
    }

    const onDelete = (e: any) => {
      e.preventDefault()
      if(window.confirm("En supprimant le module, vous supprimerez tous les éléments associés (scénarios, etc). Êtes-vous sûr de vouloir supprimer ?")) {
        if(!functions) return
        const deleteSequences = httpsCallable(functions, 'modules-call-deleteModule');
        toast.promise(deleteSequences({ trainId: trainingId, modId: id }), {
          loading: 'Suppression...',
          success: "Supprimé !",
          error: "Une erreur est survenue !"
        })
      }
    }

    return (
        <div
          className='hover:scale-105 bg-white mb-5 w-4/6 min-h-16 p-2 rounded-lg shadow-lg flex items-center justify-between outline-none'
          ref={setNodeRef}
          {...attributes}
          {...listeners}
          style={style}
        >
            <MdDragIndicator className='text-gray-500' />
            <div className='flex-1 text-gray-700 font-medium text-center'>
              Module {order + 1} : {name}
              <br/>
              <small className='text-xs italic font-normal'>Objectif(s): {goal}</small>
            </div>
            <div className='flex flex-row flex-wrap'>
                <button onClick={onClick} className='z-50 text-amber-600 font-light text-sm flex justify-center items-center flex-col mr-2'>
                  <BsKanban />
                  Scénariser
                </button>
                <button onClick={onEdit} className='z-50 text-lime-600 font-light text-sm flex justify-center items-center flex-col mr-2 '>
                  <BsFillPencilFill />
                  Modifier
                </button>
                <button onClick={onDelete} className='z-50 text-red-600 font-light text-sm flex justify-center items-center flex-col'>
                  <BsTrashFill />
                  Supprimer
                </button>
            </div>
        </div>
    )
}

export default ModuleCard;